<template>
    <div>
        <template v-if="crud_industries == true">
            <div class="page-top mb-1 mb-3">
                <h1> Add Industry Type</h1>
            </div>
            <div class="global-main">
                <form id="cityForm" @submit.prevent="addIndustryTypeData">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Name </label>
                            <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label class="label block-label"> Is Active <em class="required">*</em> </label>
                            <select v-model="form.is_active" name="carry_forward" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('is_active') }">
                                <option value="1" selected>Yes</option>
                                <option value="0" >No</option>
                            </select>
                            <has-error :form="form" field="is_active"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Risk Rating </label>
                            <select v-model="form.risk_rating_id" name="risk_rating_id" class="selectpicker custom-select2" :class="{ 'form-control is-invalid': form.errors.has('risk_rating_id') }">
                                <option value="" selected>Select Risk Rating</option>
                                <option v-for="rRating in riskRatings" v-bind:value="rRating.id" v-bind:key="rRating.id">
                                    {{ rRating.rating }}
                                </option>
                            </select>
                            <has-error :form="form" field="risk_rating_id"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/industryTypes" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="crud_industries === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_industries === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    name : '',
                    is_active : '',
                    risk_rating_id: ''
                }),
                crud_industries: null,
                riskRatings: []
            }
        },
        methods: {
            addIndustryTypeData() {
                this.$Progress.start();
                this.form.post('api/addOrUpdateIndustryType')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Industry Type created successfully');
                        this.$router.push('/industryTypes');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.promptValidationErrors(err, 'Some error in your form data');
                    this.$Progress.fail();
                })
            },
            getRiskRatings(){
                axios.get('/api/riskRatings')
                .then(res => {
                    this.riskRatings = res.data.data;
                }).then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    console.log(err);
                });
            }
        },
        mounted() {
            this.$Progress.start();
			this.can('crud_cities').then(result => {
                this.crud_industries = result.crud_cities;
            }).then(result => {
                if(this.crud_industries == true){
                    this.getRiskRatings();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
    }
</script>
